(function ($) {
  $(function () {
    // Update price on variation change.
    const $variation = $(".single_variation");
    if ($variation.length) {
      $variation.on("show_variation", function () {
        $("p.price").html(
          $(".single_variation_wrap .woocommerce-variation-price .price").html()
        );
      });
    }

    // Display laser engraved form when laser engraving is selected.
    $("#laser-engraved").on("change", function () {
      $("#form-custom-laser-engraved").toggle($(this).val() === "Yes");
    });
  });
})(jQuery);
